<template>
  <el-card shadow="hover" class="search-panel">
    <div class="search-panel-wrap">
      <el-form :model="data" :rules="ruleList" ref="form">
        <el-form-item v-for="(item, index) in fileList" v-bind:key="index" v-if="item.show !== false"
                      :label="item.label" :label-width="item.labelWidth ? item.labelWidth : labelWidth" :prop="item.prop">
          <!-- input/number -->
          <el-input v-if="item.type === 'input' || item.type === 'number'"
                    v-model="data[item.prop]"
                    :type="item.type"
                    :placeholder="item.placeholder || '请输入'"
                    :disabled="item.disabled"></el-input>
          <!-- textarea -->
          <el-input v-if="item.type === 'textarea'"
                    v-model="data[item.prop]"
                    :type="item.type"
                    :placeholder="item.placeholder || '请输入'"
                    :disabled="item.disabled"
                    :maxlength="item.max"
                    :rows="10"
                    show-word-limit></el-input>
          <!-- password -->
          <el-input v-if=" item.type === 'password'"
                    v-model="data[item.prop]"
                    :type="item.type"
                    :placeholder="item.placeholder || '请输入'"
                    :disabled="item.disabled"
                    :show-password="isShowPwd"
                    @change="changePwd"
                    autocomplete="off"></el-input>
          <!-- switch -->
          <el-switch v-if="item.type === 'switch'"
                     v-model="data[item.prop]" :active-value="1" :inactive-value="0"></el-switch>
          <!-- text -->
          <span v-if="item.type === 'text'">
              <span v-if="item.textContent">{{item.textContent}}</span>
              <span v-else>{{data[item.prop]}}</span>
            </span>
          <!-- select -->
          <el-select
            :disabled="item.disabled"
            @change="(val) => item.onChange ? item.onChange(val) : null"
            v-if="item.type === 'select'" :multiple="item.multiple" :placeholder="'请选择'" v-model="data[item.prop]">
            <el-option v-for="(option, index) in item.options" v-bind:key="index"
                       :disabled="item.disabledProp ? option[item.disabledProp] === item.disabledValue : false"
                       :value="option.val || option.id || option.value" :label="option.name || option.label"></el-option>
          </el-select>
          <!-- datePicker -->
          <el-date-picker
            v-if="item.type === 'datePicker'"
            v-model="data[item.prop]"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
          <!--datePickerRange-->
          <el-date-picker
            v-if="item.type === 'datePickerRange'"
            v-model="data[item.prop]"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <!--dateTimePickerRange-->
          <el-date-picker
            v-if="item.type === 'dateTimePickerRange'"
            v-model="data[item.prop]"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <!-- cascader -->
          <el-cascader
            v-if="item.type === 'cascader'"
            v-model="data[item.prop]"
            :options="item.options"
            :props="item.props"
            @change="handleChange">
          </el-cascader>
          <!-- uploadPicture -->
          <el-row v-if="item.type === 'uploadPicture'" class="upload-piture-box">
            <el-upload
              :disabled="item.disabled"
              class="avatar-uploader"
              :action="$global.httpBaseURL + $global.uploadPath"
              :data="uploadData"
              :show-file-list="false"
              :on-success="(res, file) => handleAvatarSuccess(res, file, item.prop, item)"
              :before-upload="beforeAvatarUpload">
              <img v-if="data[item.prop] && data[item.prop].attachUrl" :src="data[item.prop].attachUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <span class="upload-picture_tip">{{'图片尺寸'}}{{item.width}} X {{item.height}},{{'不能大于1M'}}</span>
          </el-row>
          <!-- colorPicker -->
          <el-color-picker v-if="item.type === 'colorPicker'"
                           v-model="data[item.prop]"></el-color-picker>
          <!-- slot -->
          <template v-if="item.type === 'slot'">
            <slot :name="'form-' + item.prop" />
          </template>
          <el-tooltip v-if="item.tip" class="item" effect="dark" placement="right-start">
            <div slot="content">
              <span v-if="typeof item.tip === 'string'">{{item.tip}}</span>
              <div v-else>
                <p v-for="(item,index) in item.tip" :key="index">{{item}}</p>
              </div>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">{{'搜索'}}</el-button>
          <el-button @click="resetForm">{{'重置'}}</el-button>
        </el-form-item>
      </el-form>

    </div>
  </el-card>
</template>

<script>
export default {
  name: 'searchsPanel',
  data () {
    return {
    }
  },
  components: {
  },
  props: ['data', 'ruleList',
    'fileList', 'labelWidth', 'search', 'handleChange'], // 接收父组件的方法
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    resetForm () {
      // this.$refs.form.resetFields()
      this.emptyForm()
      if (this.$parent.$refs.warehouseSelect) {
        this.$parent.$refs.warehouseSelect.setValue()
      }
      if (this.$parent.$parent.$refs.warehouseSelect) {
        this.$parent.$parent.$refs.warehouseSelect.setValue()
      }
      console.log(this.$parent)
      if (this.$parent.getList) return this.$parent.getList()
      this.$parent.$parent.getList()
    },
    // 清空
    emptyForm () {
      for (let key in this.data) {
        this.data[key] = ''
      }
    }
  }
}
</script>

<style scoped>
  .search-panel {
    margin-bottom: 10px;
  }

  .search-panel-wrap {
    display: flex;
    flex-wrap: wrap;
  }

  .search-panel .el-form {
    /*display: inline-block;*/
    display: flex;
    flex-wrap: wrap;
    margin-right: 30px;
  }

  .search-panel .el-input,
  .search-panel .el-select {
    width: 200px !important;
  }

  .search-panel .el-form-item {
    padding-right: 20px !important;
    padding-bottom: 20px !important;
    margin-bottom: 0px !important;
    display: inline-block;
  }

  .search-panel .el-button {
    padding: 0 20px;
    height: 36px;
    line-height: 36px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Table/SearchPanel.vue